module.exports = __webpack_public_path__ + "static/p_4-efa812ee14573868b196fa8f3ec8b529.png";